<script setup lang="ts">
import { cn } from '@laam/lib/utils';
import { PhCaretDown } from '@phosphor-icons/vue';
import {
	SelectScrollDownButton,
	type SelectScrollDownButtonProps,
	useForwardProps,
} from 'radix-vue';
import { type HTMLAttributes, computed } from 'vue';

const props = defineProps<
	SelectScrollDownButtonProps & { class?: HTMLAttributes['class'] }
>();

const delegatedProps = computed(() => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<SelectScrollDownButton
		v-bind="forwardedProps"
		:class="
			cn('py-xs flex cursor-default items-center justify-center', props.class)
		"
	>
		<slot>
			<PhCaretDown class="h-3xl w-3xl" weight="fill" />
		</slot>
	</SelectScrollDownButton>
</template>
